<template>
  <div class="mode-select">
    <div class="mode-select-header">
      <el-button @click="back" class="mode-select-back-button" type="text">
        <i class="el-icon-arrow-left" /> К списку моделей
      </el-button>
      <div class="mode-select-model">
        <r-text type="caption"> Модель: {{ model.name }} </r-text>
      </div>
    </div>
    <r-title type="subtitle-1" style="margin-bottom: 16px;">
      Выберите инструмент
    </r-title>
    <div class="mode-select-content">
      <ul class="mode-select-list">
        <li
          :class="`mode-select-item ${mode.id}`"
          v-for="mode in modes"
          :key="mode.id"
          @click="setMode(mode.id)"
        >
          <div class="mode-select-item-icon">
            <r-icon :name="mode.icon" :size="24" />
          </div>
          <div class="mode-select-item-info">
            <r-text style="margin-bottom: 4px;">
              {{ mode.name }}
            </r-text>
            <r-text type="caption">
              {{ mode.description }}
            </r-text>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
const modes = [
  {
    id: "calculations",
    name: "Запуск расчетов",
    icon: "tasks",
    description:
      "Данный инструмент предназначен для запуска расчетов с необходимыми параметрами"
  },
  {
    id: "vizualization",
    name: "Просмотр результатов",
    icon: "vizualization",
    description:
      "Данный инструмент предназначен для визуализации результатов расчетов"
  }
];

export default {
  data() {
    return {
      modes
    };
  },
  computed: {
    model() {
      return this.$store.state.scenarioModelling.model;
    }
  },
  methods: {
    back() {
      this.$emit("back-to-model-list");
    },
    setMode(mode) {
      if (mode === "calculations") {
        this.$store.commit("SET_SM_STATE_PROP", {
          name: "view",
          value: "calculations"
        });
        return;
      }

      this.$store.commit("SET_SM_STATE_PROP", { name: "mode", value: mode });
    }
  }
};
</script>

<style lang="scss">
.mode-select {
  max-width: 440px;

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .el-button {
      padding: 0;
      font-size: 12px;
    }
  }

  &-item {
    position: relative;
    padding: 8px 16px;
    display: flex;
    border-radius: var(--border-radius);
    background-color: var(--modal_bg) !important;
    cursor: pointer;

    &.settings {
      margin-top: 32px;

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: -16px;
        left: -16px;
        height: 1px;
        width: calc(100% + 32px);
        background-color: var(--dividers_low_contrast) !important;
      }
    }

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2) !important;
    }
    &:active {
      background-color: rgba(var(--accent_primary), 0.3) !important;
    }

    &-icon {
      margin-right: 16px;
      flex-shrink: 0;
    }
  }
}
</style>
